export enum PartyType {
  PAYER = 'PAYER',
  PAYEE = 'PAYEE',
  ADDITIONAL_PAYER = 'ADDITIONAL_PAYER',
  ADDITIONAL_PAYEE = 'ADDITIONAL_PAYEE',
  SUPERINTENDENT = 'SUPERINTENDENT',
}

export enum PartyRole {
  INVITER = 'INVITER',
  INVITEE = 'INVITEE',
}

export enum NatureOfPerson {
  SELF = 'SELF',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
  GUARDIAN = 'GUARDIAN',
  EXECUTOR = 'EXECUTOR',
  LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',
  DIRECTOR_OF_CORPORATION = 'DIRECTOR_OF_CORPORATION',
  OTHER = 'OTHER',
}

export enum ContractPartyTag {
  ACCESS_LINKED_CONTRACT_GRANTED = 'ACCESS_LINKED_CONTRACT_GRANTED',
  ACCESS_FUNDED_HEAD_BUILDING_CONTRACT_GRANTED = 'ACCESS_FUNDED_HEAD_BUILDING_CONTRACT_GRANTED',
  NON_CONTRACTUAL_PARTY = 'NON_CONTRACTUAL_PARTY',
  JOIN_BY_LINKED_CONTRACT = 'JOIN_BY_LINKED_CONTRACT',
}

export enum PartyLinkingStatus {
  'UNLINKED' = 'UNLINKED',
  'LINKED' = 'LINKED',
  'FILLED_INFO' = 'FILLED_INFO',
  'READY_TO_SIGN' = 'READY_TO_SIGN',
  'SIGNED' = 'SIGNED',
  'SIGNING' = 'SIGNING',
  'DECLINED_ON_PROVIDER' = 'DECLINED_ON_PROVIDER',
  'JOINED' = 'JOINED',
}

export enum PayType {
  PAYER = 'PAYER',
  PAYEE = 'PAYEE',
  INTERMEDIARY = 'INTERMEDIARY',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum WitnessForSubType {
  INDIVIDUAL = 'INDIVIDUAL',
  INDIVIDUAL_TRUST = 'INDIVIDUAL_TRUST',
  SOLE_TRADER = 'SOLE_TRADER',
  PARTNERSHIP = 'PARTNERSHIP',
}
